import { render, staticRenderFns } from "./projectSync.vue?vue&type=template&id=4da370d8&scoped=true"
import script from "./projectSync.vue?vue&type=script&lang=js"
export * from "./projectSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da370d8",
  null
  
)

export default component.exports